import { api } from '@gik/core/api';
import { ISendContactFormValues } from '@gik/contact/components/ContactForm/ContactForm';

export async function sendContact(values: ISendContactFormValues) {
  const response = await api.post(`contact/send`, {
    json: values,
  });

  if (!response.ok) {
    throw new Error((await response.json()).message);
  }
}
